import React, { useState, useEffect, useContext } from 'react';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import { getGetRequestOptions } from "../components/GetToken";
import { AppContext } from '../context/AppContext';
import validationMessage from '../helpers/ValidationErrorMsg'
import { Button } from "react-bootstrap";

const customStylesSelect = {
	control: (provided) => ({
		...provided,
		height: 'calc(1.35em + 1.1rem + 2px)',
		minHeight: '35px'
	}),
	valueContainer: (provided) => ({
		...provided,
	})
};

const LogBookFuelEdit = (props) => {
	const { jwt } = useContext(AppContext);
	const [allBusinessUnits, setAllBusinessUnits] = useState([]);
	const [state, setState] = useState({
		logBookBusinessUnit: "",
		projectId: "",
		equipment: "",
		fuelType: "",
		tankCapacity: "",
		fuelQty: "",
		refuelingDate: "",
		currentHrsMeter: ""
	});
	const [vehicleSearchKey, setVehicleSearchKey] = useState(0);

	useEffect(() => {
		getAllBu();
	}, []);

	useEffect(() => {
		if (props.fuelLogId) {
			getFuelLogDetails(props.fuelLogId);
		}
	}, [props.fuelLogId]);

	const getFuelLogDetails = (fuelLogId) => {
		fetch(process.env.REACT_APP_API_URL + "log_book/fuel_edit/" + fuelLogId,
			getGetRequestOptions())
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				if (resp.success === true) {
					const data = resp.data;
					setState({
						logBookBusinessUnit: { value: data.project.projectId, label: data.project.projectName, isdisabled: data.project.projectName === 'EMD' ? true : false },
						projectId: data.project.projectId,
						equipment: { value: data.equipment.value, label: data.equipment.label },
						fuelType: data.equipment.fuelType,
						tankCapacity: data.equipment.tankCapacity,
						fuelQty: data.fuelQty,
						refuelingDate: data.logDate,
						currentHrsMeter: data.hrsMeter,
						emoDetailsId: data.emoDetailsId
					});
				} else {
					Swal.fire({
						icon: 'error',
						title: 'Error',
						text: resp.errorMessage || 'Failed to fetch fuel log details',
					});
				}
			})
			.catch((error) => {
				console.log(error, "catch the hoop")
			});
	}

	const getAllBu = () => {
		fetch(process.env.REACT_APP_API_URL + "get_user_business_units",
			getGetRequestOptions())
			.then((resp) => resp.json())
			.then((resp) => {
				let tempResp = resp.data.map(function (element) {
					return { ...element, label: element.projectName, value: element.projectId, isdisabled: element.projectName === 'EMD' ? false : true }
				});
				setAllBusinessUnits(tempResp);
			})
			.catch((error) => {
				console.log(error, "catch the hoop")
			});
	}

	const getEquipment = (inputValue, callback) => {
		if (!state.logBookBusinessUnit || !state.logBookBusinessUnit.projectId) {
			callback([]);
			return;
		}
		var url = "";
		if (!inputValue) {
			url = process.env.REACT_APP_API_URL + "equipment/received_equipment_search/" + state.logBookBusinessUnit.projectId;
		} else {
			url = process.env.REACT_APP_API_URL + "equipment/received_equipment_search/" + state.logBookBusinessUnit.projectId + "?q=" + inputValue;
		}
		setTimeout(() => {
			fetch(url, getGetRequestOptions())
				.then((resp) => resp.json())
				.then((resp) => {
					const tempArray = resp.data.map(function (element) {
						element.label = `${element.equipmentName} (${element.equipmentCode})`;
						element.value = element.equipmentId;
						return element;
					});
					callback(tempArray);
				})
				.catch((error) => {
					console.log(error, "catch the hoop")
				});
		});
	}

	const handleEquipmentChange = equipment => {
		setState(prev => ({
			...prev,
			equipment: equipment,
			fuelType: equipment.fuelType || "",
			tankCapacity: equipment.tankCapacity || "",
			previousHrsMeter: equipment.previousHrsMeter || ""
		}));
	}

	const handleBuChange = logBookBusinessUnit => {
		setState(prev => ({ ...prev, logBookBusinessUnit, projectId: logBookBusinessUnit.projectId, equipment: "", fuelType: "", tankCapacity: "", previousHrsMeter: "" }));
		setVehicleSearchKey(vehicleSearchKey + 1);
	}

	const handleInputOnChange = (name, value) => {
		setState(prev => ({ ...prev, [name]: value }));
	};

	const handleSubmit = evt => {
		evt.preventDefault();

		const formData = {
			projectId: state.projectId,
			equipment: state.equipment.value,
			fuelType: state.fuelType,
			tankCapacity: state.tankCapacity,
			fuelQty: state.fuelQty,
			refuelingDate: state.refuelingDate,
			hrsMeter: state.currentHrsMeter,
			emoDetailsId: state.equipment.emoDetailsId || ""
		}

		Swal.fire({
			title: 'Are you sure?',
			text: "You want to update this fuel log!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'No'
		}).then((result) => {
			if (result.value) {
				const requestOptions = {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwt.token },
					body: JSON.stringify(formData)
				};

				fetch(process.env.REACT_APP_API_URL + "log_book/fuel_update/" + props.fuelLogId, requestOptions)
					.then((resp) => resp.json())
					.then((resp) => {
						if (resp.success === true) {
							let successMsg = resp.successMessage;
							Swal.fire({
								icon: 'success',
								title: 'Success',
								text: successMsg,
							})

							setState({
								logBookBusinessUnit: "",
								projectId: "",
								equipment: "",
								fuelType: "",
								tankCapacity: "",
								fuelQty: "",
								refuelingDate: "",
								currentHrsMeter: ""
							});
							props.onUpdateFuelLog();
						} else {
							const errorsMessage = validationMessage(resp.errorMessage).join("<br>");
							Swal.fire({
								icon: 'error',
								title: 'Error',
								html: errorsMessage,
							})
						}
					})
					.catch((error) => {
						console.log(error, "catch the hoop");
						Swal.fire({
							icon: 'error',
							title: 'Error',
							text: 'An error occurred while submitting the form',
						});
					});
			}
		});
	}

	return (
		<>
			<form onSubmit={handleSubmit}>
				<div className="card-body">
					<div className="ml-12">
						<div className='row'>
							<div className='col-12'>
								<div className="form-group row">
									<label htmlFor="example-text-input" className="col-lg-4 col-form-label">Business Unit<span className="required text-danger"> *</span></label>
									<div className="col-lg-6">
										<Select
											value={state.logBookBusinessUnit}
											onChange={handleBuChange}
											options={allBusinessUnits}
											styles={customStylesSelect}
											placeholder="Select Business Unit"
											isDisabled={true}
										/>
									</div>
								</div>
								<div className="form-group row">
									<label htmlFor="example-text-input" className="col-lg-4 col-form-label">Equipment<span className="required text-danger"> *</span></label>
									<div className="col-lg-6">
										<AsyncSelect
											key={vehicleSearchKey}
											value={state.equipment}
											defaultOptions
											loadOptions={getEquipment}
											placeholder="Select Equipment"
											onChange={handleEquipmentChange}
											styles={customStylesSelect}
											isDisabled={true}
										/>
									</div>
								</div>
								<div className="form-group row">
									<label htmlFor="fuelType" className="col-lg-4 col-form-label">Fuel Type<span className="required text-danger"> *</span></label>
									<div className="col-lg-6">
										<input type="text" name="fuelType" id="fuelType" value={state.fuelType} readOnly className={`form-control form-control-md`} />
									</div>
								</div>
								<div className="form-group row">
									<label htmlFor="tankCapacity" className="col-lg-4 col-form-label">Tank Capacity<span className="required text-danger"> *</span></label>
									<div className="col-lg-6">
										<div className="input-group">
											<div className="input-group-prepend">
												<span className="input-group-text">L</span>
											</div>
											<input type="text" name="tankCapacity" id="tankCapacity" value={state.tankCapacity} readOnly className={`form-control form-control-md`} />
										</div>
									</div>
								</div>
								<div className="form-group row">
									<label htmlFor="fuelQty" className="col-lg-4 col-form-label">Fuel Quantity<span className="required text-danger"> *</span></label>
									<div className="col-lg-6">
										<div className="input-group">
											<div className="input-group-prepend">
												<span className="input-group-text">L</span>
											</div>
											<input type="number" name="fuelQty" id="fuelQty" value={state.fuelQty} onChange={(e) => handleInputOnChange('fuelQty', e.target.value)} className={`form-control form-control-md`} />
										</div>
									</div>
								</div>
								<div className="form-group row">
									<label htmlFor="refuelingDate" className="col-lg-4 col-form-label">Refueling Date<span className="required text-danger"> *</span></label>
									<div className="col-lg-6">
										<input type="date" name="refuelingDate" id="refuelingDate" value={state.refuelingDate} onChange={(e) => handleInputOnChange('refuelingDate', e.target.value)} className={`form-control form-control-md`} />
									</div>
								</div>
								<div className='form-group row'>
									<label htmlFor="currentHrsMeter" className="col-lg-4 col-form-label">Current Hrs Meter<span className="required text-danger"> *</span></label>
									<div className="col-lg-6">
										<input type="number" name="currentHrsMeter" id="currentHrsMeter" value={state.currentHrsMeter} onChange={(e) => handleInputOnChange('currentHrsMeter', e.target.value)} className={`form-control form-control-md`} />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="form-group row">
					<div className="col-sm-12 d-flex justify-content-center">
						<Button type="submit" variant="primary" className="mr-2">
							Update
						</Button>
						<Button variant="secondary" onClick={props.onHide}>
							Cancel
						</Button>
					</div>
				</div>
				{/* <pre>{JSON.stringify(state, null, 2)}</pre> */}
			</form>
		</>
	);
}

export default LogBookFuelEdit;